import { createSlice } from "@reduxjs/toolkit"
import { performanceActions } from "../../assets/staticData";

let initialData:any = {
    tabs: [
        'ACTION_PLAN',
    ],
    currentTab: 'ACTION_PLAN',
    isActions: false,
    projects: null,
    selectedProject: null,
    details: null,
    allActions: null,
    selectedAction: null,
    projectsSearchString: '',
    actionsSearchString: '',
    projectsArchivedFilter: [],
    actionsArchivedFilter: [],
    actionsLinkedToFilter: [],
}

export const actionPlan = createSlice({
    name: 'actionPlan',
    initialState: initialData,
    reducers: {
        setCurrentTab: (state:any, action:any) => {
            state.currentTab = action.payload;
            return state;
        },
        setIsActions: (state:any, action:any) => {
            state.isActions = action.payload;
            return state;
        },
        setProjects: (state:any, action:any) => {
            state.projects = action.payload;
            return state;
        },
        setSelectedProject: (state:any, action:any) => {
            state.selectedProject = action.payload;
            return state;
        },
        resetSelectedProject: (state:any) => {
            state.selectedProject = initialData.selectedProject;
            return state;
        },
        setProjectDetails: (state:any, action:any) => {
            state.details = action.payload;
            return state;
        },
        resetsetProjectDetails: (state:any) => {
            state.details = initialData.details;
            return state;
        },
        setAllActions: (state:any, action:any) => {
            state.allActions = action.payload;
            return state;
        },
        setSelectedAction: (state:any, action:any) => {
            state.selectedAction = action.payload;
            return state;
        },
        resetSelectedAction: (state:any) => {
            state.selectedAction = initialData.selectedAction;
            return state;
        },
        setProjectsSearchString: (state:any, action:any) => {
            state.projectsSearchString = action.payload;
            return state;
        },
        setActionsSearchString: (state:any, action:any) => {
            state.actionsSearchString = action.payload;
            return state;
        },
        setProjectsArchivedFilter: (state: any, action: any) => {
            state.projectsArchivedFilter = action.payload;
            return state;
        },
        resetProjectsArchivedFilter: (state: any) => {
            state.projectsArchivedFilter = initialData.leagueFilter;
            return state;
        },
        setActionsArchivedFilter: (state: any, action: any) => {
            state.actionsArchivedFilter = action.payload;
            return state;
        },
        resetActionsArchivedFilter: (state: any) => {
            state.actionsArchivedFilter = initialData.leagueFilter;
            return state;
        },
        setActionsLinkedToFilter: (state: any, action: any) => {
            state.actionsLinkedToFilter = action.payload;
            return state;
        },
        resetActionsLinkedToFilter: (state: any) => {
            state.actionsLinkedToFilter = initialData.leagueFilter;
            return state;
        },
        resetActionPlan: (state:any) => {
            state = initialData;
            return state;
        },
    }
});

export const {
    setCurrentTab,
    setIsActions,
    setProjects,
    setSelectedProject,
    resetSelectedProject,
    setProjectDetails,
    resetsetProjectDetails,
    setAllActions,
    setSelectedAction,
    resetSelectedAction,
    setProjectsSearchString,
    setActionsSearchString,
    setProjectsArchivedFilter,
    resetProjectsArchivedFilter,
    setActionsArchivedFilter,
    resetActionsArchivedFilter,
    setActionsLinkedToFilter,
    resetActionsLinkedToFilter,
    resetActionPlan
} = actionPlan.actions;
export default actionPlan.reducer;